<template>
  <div class="content">
    <v-header></v-header>
    <div class="details">
        <h1>{{ info.title }}</h1>
        <p class="box">
            <span class="s1">{{ $parseLabel('发布时间') + ': ' + releaseTime }}</span>
            <span class="s2">{{ $parseLabel('发布人') +': admin' }}</span>
        </p>
        <div class="cons" v-html="info.content"></div>
    </div>
    <v-footer></v-footer>
  </div>
</template>
    
  <script>
import { getVoiceItem } from "@/api/list";
import header from "@/components/header.vue";
import footer from "@/components/footer.vue"
import moment from "moment";
export default {
  data() {
    return {
      info: {},
      releaseTime: undefined
    };
  },
  components: {
    "v-header": header,
    "v-footer": footer,
    moment
  },
  created() {
    let voiceId = JSON.parse(sessionStorage.getItem('details')).id
    console.log("this.info", this.info)

    getVoiceItem(voiceId).then((res) => {
      this.info = Object.assign({}, res.data);
      this.releaseTime = moment(this.info.releaseDate).format("YYYY-MM-DD HH:mm:SS");
      console.log("this.releaseTime", this.releaseTime)
    });
  }
};
</script>
    
<style lang="less" scoped>
.content {
    background: #fff;
    .details {
      padding-top: 20px;
      h1 {
        width: 85%;
        height: 60px;
        line-height: 55px;
        margin: auto;
        text-align: center;
        font-size: 23px;
      }
        .box {
          width: 85%;
          margin: auto;
          text-align: center;
          margin-bottom: 15px;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          padding-bottom: 20px;
          font-size: 16px;
          .s1 {
            margin-right: 10px;
            margin-left: 10px;
          }
        }
        .cons {
          width: 85%;
          margin: auto;
        }
        // /deep/ .cons img {
        //   width: 100% !important;
        // }
        // /deep/ .cons video {
        //   width: 100% !important;
        // }
    }
}
</style>